export default __webpack_public_path__ + "static/media/Sheet-Metal-Vendors.8f352733.jpg";